import React from 'react';
import { moduleHost } from '../../infrastructure/components/root-module-host';
import { EventsList } from './_events-list/events-list';
import { EventsModulePage, EventsVM } from './events.viewmodel';
import { connectEventsVM, EventsContext } from './events.context';
import { ManageEvent } from './_manage-event/manage-event';
import './events.scss';

interface IProps {
    page: EventsModulePage;
    isLoadingAccount: boolean;
}

const EventsDisconnected = (props: IProps) => {
    if (props.page === EventsModulePage.ManageEvent) return <ManageEvent />;

    return props.isLoadingAccount
        ? <div>Loading account information...</div>
        : <EventsList />
    ;
};

const EventsContainer = connectEventsVM<IProps>(EventsDisconnected, vm => {
    return {
        page: vm.getPage(),
        isLoadingAccount: vm.isLoadingAccount() || !vm.getAccount(),
    };
});

const Events = moduleHost(EventsVM, EventsContext, EventsContainer);

export { Events };
